/**
 * Web polyfills for React Native components and libraries
 */

import { Platform } from 'react-native';

// 防止全局变量冲突
if (typeof window !== 'undefined') {
  // 清除可能存在的conflux相关全局变量（可能来自浏览器扩展）
  try {
    if (window.conflux && typeof window.conflux === 'object') {
      console.warn('Conflux global variable detected, cleaning up...');
      // 使用更安全的方式处理全局变量冲突
      Object.defineProperty(window, 'conflux', {
        value: undefined,
        writable: false,
        configurable: true
      });
    }
  } catch (e) {
    console.warn('Global variable cleanup failed:', e);
    // 如果无法清除，至少不要让它影响应用
  }
  
  // 防止其他可能的全局变量冲突
  const conflictingGlobals = ['conflux', 'ethereum', 'web3'];
  conflictingGlobals.forEach(globalName => {
    try {
      if (window[globalName] && typeof window[globalName] === 'object') {
        const descriptor = Object.getOwnPropertyDescriptor(window, globalName);
        if (descriptor && !descriptor.configurable) {
          console.warn(`Cannot cleanup non-configurable global: ${globalName}`);
        }
      }
    } catch (e) {
      // Ignore errors for read-only properties
    }
  });
}

// Only apply polyfills on web platform
if (Platform.OS === 'web') {
  
  // AsyncStorage polyfill for web
  const AsyncStoragePolyfill = {
    async getItem(key) {
      try {
        return localStorage.getItem(key);
      } catch (error) {
        console.warn('localStorage getItem error:', error);
        return null;
      }
    },
    
    async setItem(key, value) {
      try {
        localStorage.setItem(key, value);
      } catch (error) {
        console.warn('localStorage setItem error:', error);
      }
    },
    
    async removeItem(key) {
      try {
        localStorage.removeItem(key);
      } catch (error) {
        console.warn('localStorage removeItem error:', error);
      }
    },
    
    async clear() {
      try {
        localStorage.clear();
      } catch (error) {
        console.warn('localStorage clear error:', error);
      }
    },
    
    async getAllKeys() {
      try {
        return Object.keys(localStorage);
      } catch (error) {
        console.warn('localStorage getAllKeys error:', error);
        return [];
      }
    }
  };

  // BackgroundTimer polyfill for web
  const BackgroundTimerPolyfill = {
    setTimeout(callback, delay) {
      return setTimeout(callback, delay);
    },
    
    setInterval(callback, delay) {
      return setInterval(callback, delay);
    },
    
    clearTimeout(timeoutId) {
      return clearTimeout(timeoutId);
    },
    
    clearInterval(intervalId) {
      return clearInterval(intervalId);
    },
    
    start(delay = 0) {
      // For web, we don't need special background handling
      if (delay > 0) {
        return setTimeout(() => {
          console.log('Background timer started');
        }, delay);
      }
    },
    
    stop() {
      // No-op for web
      console.log('Background timer stopped');
    }
  };

  // Alert polyfill for web
  const AlertPolyfill = {
    alert(title, message, buttons) {
      if (typeof title === 'string' && typeof message === 'string') {
        // Multi-button alert
        if (buttons && buttons.length > 1) {
          const result = window.confirm(`${title}\n\n${message}`);
          const button = buttons.find(b => result ? b.style !== 'cancel' : b.style === 'cancel');
          if (button && button.onPress) {
            button.onPress();
          }
        } else {
          // Single button alert
          window.alert(`${title}\n\n${message}`);
          if (buttons && buttons[0] && buttons[0].onPress) {
            buttons[0].onPress();
          }
        }
      } else {
        // Simple alert
        window.alert(title);
      }
    }
  };

  // Apply polyfills to global scope safely
  if (typeof window !== 'undefined') {
    // Make AsyncStorage available globally for web
    try {
      if (!window.AsyncStorage) {
        Object.defineProperty(window, 'AsyncStorage', {
          value: AsyncStoragePolyfill,
          writable: false,
          configurable: true
        });
      }
    } catch (e) {
      console.warn('AsyncStorage polyfill already exists');
    }
    
    // Make BackgroundTimer available globally for web
    try {
      if (!window.BackgroundTimer) {
        Object.defineProperty(window, 'BackgroundTimer', {
          value: BackgroundTimerPolyfill,
          writable: false,
          configurable: true
        });
      }
    } catch (e) {
      console.warn('BackgroundTimer polyfill already exists');
    }
  }
  
  // Add Alert polyfill for web
  if (typeof window !== 'undefined' && !window.Alert) {
    try {
      Object.defineProperty(window, 'Alert', {
        value: AlertPolyfill,
        writable: false,
        configurable: true
      });
    } catch (e) {
      console.warn('Alert polyfill setup failed:', e);
    }
  }

  // URL polyfill (react-native-url-polyfill equivalent for web)
  if (typeof URL === 'undefined') {
    global.URL = require('whatwg-url').URL;
  }
  
  // Fetch polyfill if needed
  if (typeof fetch === 'undefined') {
    global.fetch = require('whatwg-fetch').fetch;
  }
}